import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Container,
  Box,
  Button,
  TextField,
  FormControlLabel,
  Radio,
  Modal,
  Tooltip,
} from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';

// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';
import { useForm, FormProvider } from 'react-hook-form';
import { date, object, string, any } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ErrorIcon from '@mui/icons-material/Error';
// import {ReactComponent as CalendarIcon} from '../../../assets/svg/calendar.svg';
import { useDispatch, useSelector } from "react-redux";
import FormInput from "../../../components/form/FormInput";
import { APPOINTMENT_DETAIL } from "../../../redux/types";

const durationList = [
  { title: '1 hr', duration: 1 },
  { title: '1.5 hrs', duration: 1.5 },
  { title: '2 hrs', duration: 2 },
  { title: '3 hrs', duration: 3 },
  { title: '4 hrs', duration: 4 },
  { title: '6 hrs', duration: 6 },
  { title: '8 hrs', duration: 8 },
  { title: '12 hrs', duration: 12 },
  { title: '24 hrs', duration: 24 },
  { title: '48 hrs', duration: 48 },
  { title: '72 hrs', duration: 72 },
  { title: 'Custom', duration: 0 },
]

// const appointmentSchema = object({
//   // preferredDate: date({
//   //   required_error: "Please select a date and time",
//   //   invalid_type_error: "That's not a date!",
//   // }),
//   // duration: union([string(), z.null()]).refine((val) => val !== null, {
//   //   message: "Please, make a choice!"
//   // }),
//   // duration: literal(true, {
//   //   errorMap: () => ({ message: "You must accept Terms and Conditions" }),
//   // }),
//   // accept: z.literal(true, {
//   //   invalid_type_error: "You must accept Terms and Conditions.",
//   // }),
//   message: string().min(1, 'Busines description is required'),
// });

const AppointmentDetail = ({ activeStep, onhandleNext, onhandleBack, length }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const [valueDuration, setValueDuration] = useState(1);
  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);

  const { bookFormTheme, bookingData, durationOptions } = useSelector(state => ({
    bookFormTheme: state.book.emailNotification.bookFormTheme,
    durationOptions: state.book.emailNotification.durationOptions,
    bookingData: {
      bookingType: state.book.bookingType,
      preferredDate: state.book.preferredDate,
      duration: state.book.duration,
      message: state.book.message,
      location: state.book.location,
    }
  }));

  const StyledFormControlLabel = styled((props) => <FormControlLabel {...props} />)(
    ({ theme, checked }) => ({
      display: 'flex',
      backgroundColor: checked ? bookFormTheme ? '#50cd89' : '#212e48' : 'transparent',
      border: checked ? `1px solid #50cd89` : '1px dashed ' + (bookFormTheme ? '#e4e6ef' : '#323248'),
      borderRadius: '6px',
      fontWeight: 600,
      fontSize: '1.5rem',
      marginLeft: '0px',
      marginRight: '0px',
      justifyContent: 'center',
      padding: '13px',
      ".MuiTypography-root": {
        color: checked ? '#ffffff' : (bookFormTheme ? '#181c32' : '#fff'),
      },
      "&:hover": {
        backgroundColor: bookFormTheme ? '#f1faff' : '#212e48',
        border: `1px dashed ${theme.palette.primary.main}`,
      },
      "&:hover p": {
        color: '#009ef7',
      },
    }),
  );
  
  function MyFormControlLabel(props) {
    const radioGroup = useRadioGroup();
    let checked = false;
    if (radioGroup) {
      checked = radioGroup.value == props.value;
    }
    return <StyledFormControlLabel checked={checked} {...props} />;
  }

  const root = document.documentElement;
  root.style.setProperty('--background-color-mobile', bookFormTheme ? '#f5f8fa' : '#1b1b29');
  root.style.setProperty('--input-color-mobile', bookFormTheme ? '#5e6278' : '#92929f');

  const appointmentSchema = object({
    preferredDate: date({
      required_error: "Please select a date and time",
      invalid_type_error: "That's not a date!"
    }),
    location: bookingData.bookingType != 'Incall' ? string().min(1, "Location info is required.") : any(),
    message: string().min(1, 'An introduction is required.'),
  });

  // Form Handler
  const defaultValues = {
    message: ''
  };
  const methods = useForm({
    resolver: zodResolver(appointmentSchema),
    defaultValues
  });
  const { register, formState: { errors } } = methods;

  useEffect(() => {
    setValue(bookingData?.preferredDate);
    setValueDuration(bookingData?.duration);
    methods.setValue("preferredDate", bookingData?.preferredDate);
    methods.setValue("location", bookingData?.location);
    methods.setValue("message", bookingData?.message);
  }, [bookingData?.preferredDate, bookingData?.duration, bookingData?.location, bookingData?.message]);

  const handleClose = () => setOpen(false);

  // ? Form Handler
  const onSubmitHandler = (data) => {
    setOpen(false);
    const appointmentData = {
      // preferredDate: moment(value).format('YYYY/MM/DD hh:mm'),
      preferredDate: value,
      duration: valueDuration,
      message: data.message
    }
    if (bookingData.bookingType != 'Incall') {
      appointmentData.location = methods.getValues("location");
    }
    dispatch({
      type: APPOINTMENT_DETAIL,
      payload: appointmentData
    })
    onhandleNext();
  };

  return (
    <Grid
      item
      display='flex'
      alignItems='center'
      justifyContent='center'
      sx={{ flexGrow: 1, flexDirection: 'column', paddingY: '5rem', backgroundColor: bookFormTheme ? '#fff' : '#151521' }}
    >
      <Container sx={{ maxWidth: { md: '650px' } }}>
        <Grid>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, color: bookFormTheme ? '#3f4254' : '#fff' }}>Appointment Details</Typography>
        </Grid>
        <FormProvider {...methods}>
          <Box
            display='flex'
            flexDirection='column'
            component='form'
            noValidate
            autoComplete='off'
            sx={{ mt: 5 }}
            onSubmit={methods.handleSubmit(onSubmitHandler)}
          >
            <Grid
              item
              container
              alignItems='center'
              spacing={1}
            >
              <Grid item xs="4">
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: bookFormTheme ? '#3f4254' : '#fff' }}>Preferred Date & Time <span style={{ color: 'red' }}>*</span></Typography>
              </Grid>
              <Grid item xs="8">
                <Flatpickr
                  data-enable-time
                  value={value}
                  options={{
                    minDate: new Date(),
                  }}
                  onChange={([date]) => {
                    setValue(date);
                    methods.setValue("preferredDate", date);
                  }}
                  render={({ defaultValue, value, ...props }, ref) => {
                    return <input {...props} defaultValue={defaultValue} ref={ref} style={{
                      fontFamily: 'Poppins, Helvetica, sans-serif',
                      backgroundColor: bookFormTheme ? '#f5f8fa' : '#1b1b29',
                      padding: '10px 20px',
                      color: bookFormTheme ? '#5e6278' : '#92929f',
                      fontSize: '14px',
                      width: '100%',
                      boxSizing: 'border-box',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: '600',
                    }} />
                  }}
                />
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    open={openDateTimePicker}
                    onOpen={() => setOpenDateTimePicker(true)}
                    onClose={() => setOpenDateTimePicker(false)}
                    inputFormat="YYYY-MM-DD HH:mm"
                    renderInput={(props) => {
                      props.InputProps = {
                        ...props.InputProps,
                        disableUnderline: true,
                        style: {
                          color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f',
                          fontSize: '0.9rem',
                          fontWeight: 600,
                        }
                      };
                      return (
                        <TextField
                          fullWidth
                          variant="standard"
                          {...props}
                          sx={{ svg: { color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674' } }}
                          onClick={() => setOpenDateTimePicker(true)}
                        />
                      );
                    }}
                    value={value}
                    onChange={(newValue) => setValue(newValue)}
                    disableOpenPicker
                    // InputAdornmentProps={{ position: 'start' }}
                    // components={{ OpenPickerIcon: CalendarIcon }}
                  />
                </LocalizationProvider> */}
              </Grid>
            </Grid>
            {bookingData.bookingType != 'Incall' &&
              <Grid
                item
                container
                alignItems='center'
                spacing={1}
                sx={{ mt: 1 }}
              >
                <Grid item xs="4">
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: bookFormTheme ? '#3f4254' : '#fff' }}>Location <span style={{ color: 'red' }}>*</span></Typography>
                </Grid>
                <Grid item xs>
                  <FormInput
                    placeholder='Where are we meeting?'
                    type='text'
                    name='location'
                    fullWidth
                  />
                </Grid>
              </Grid>
            }
            <Grid sx={{ mt: 5 }}>
              <Typography alignItems="center" sx={{ fontSize: '14px', fontWeight: 600, color: bookFormTheme ? '#3f4254' : '#fff', mb: 1.5 }}>
                Select Booking Duration 
                <Tooltip title={'If your desired duration is not listed, or you seek a custom arrangement, select Custom and let me know in your message below.'} placement="top" enterTouchDelay={0}>
                  <ErrorIcon sx={{ color: bookFormTheme ? '#a1a5b7' : '#565674', width: '20px', height: '14px' }} /> 
                </Tooltip>
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <RadioGroup
                defaultValue={1}
                sx={{ justifyContent: 'space-between' }}
                onChange={(e, value) => setValueDuration(value)}
              >
                <Grid container rowSpacing={1} columnSpacing={1}>
                  {durationList.map((item, index) => durationOptions.includes(item.duration) && (
                    <Grid key={item.title} item xs={4} md={2}>
                      <MyFormControlLabel
                        value={item.duration}
                        label={<Typography sx={{ fontWeight: 600, fontSize: '16px' }}>{item.title}</Typography>}
                        control={<Radio sx={{ display: 'none' }} />}
                      />
                    </Grid>
                  ))}
                </Grid>
              </RadioGroup>
            </Grid>
            <Grid sx={{ mt: 5 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: bookFormTheme ? '#3f4254' : '#fff', mb: 1.5 }}>Brief Introduction <span style={{ color: 'red' }}>*</span></Typography>
              <TextField
                variant="standard"
                type="text"
                placeholder="Introduce yourself with a short message and anything else related to this booking."
                fullWidth
                multiline
                rows={5}
                name="message"
                error={!!errors['message']}
                helperText={errors['message'] ? (errors['message'].message) : ''}
                {...register('message')}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    color: bookFormTheme != null ? bookFormTheme ? '#5e6278' : '#92929f' : null,
                    background: bookFormTheme != null ? bookFormTheme ? '#f5f8fa' : '#1b1b29' : null,
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontWeight: 500,
                  },
                }}
              />
            </Grid>
          </Box>
        </FormProvider>
      </Container>
      <Grid display='flex' justifyContent='space-between' sx={{ my: 2, width: { md: '600px' } }}>
        <Button
          variant="contained"
          disabled={activeStep === 0}
          onClick={onhandleBack}
          startIcon={<ArrowBackIcon />}
          sx={{ mt: 1, mr: 1, visibility: activeStep !== 0 ? 'inherit' : 'hidden', color: '#fff', fontWeight: 600, textTransform: 'none' }}>
          Back
        </Button>
        <Button
          variant="contained"
          onClick={() => { methods.handleSubmit(onSubmitHandler)(); setOpen(true) }}
          endIcon={<ArrowForwardIcon />}
          sx={{ mt: 1, mr: 1, color: '#fff', textTransform: 'none', fontWeight: 600 }}>
          {activeStep === length - 1 ? 'Finish' : 'Continue'}
        </Button>
      </Grid>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            backgroundColor: bookFormTheme ? '#fff' : '#1e1e2d',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Grid sx={{ width: '80%', margin: 'auto' }}>
            <HighlightOffIcon color="error" sx={{ fontSize: '7rem', margin: 'auto', display: 'flex' }} />
            <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center', color: bookFormTheme ? '#3f4254' : '#fff' }}>
              Sorry, looks like there are some errors detected, please try again.
            </Typography>
            <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
              <Button variant="contained" sx={{ fontSize: '0.8rem', fontWeight: 600, textTransform: 'none', color: '#fff', backgroundColor: bookFormTheme && '#f1416c', boxShadow: 'none' }} onClick={handleClose}>Go back</Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  )
}

export default AppointmentDetail;
